import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useNavigate, useParams, Link } from 'react-router-dom'
import { ChevronLeft } from 'lucide-react'
import { adminApi } from '@/lib/api'
import { ThemePresetForm } from './_form'
import type { ThemePresetFormValues } from './_form'

export default function EditThemePresetPage() {
  const { id } = useParams<{ id: string }>()
  const qc = useQueryClient()
  const navigate = useNavigate()

  const { data: preset, isLoading, error } = useQuery({
    queryKey: ['admin', 'theme-preset', id],
    queryFn: () => adminApi.themePresets.get(id!),
    enabled: !!id,
  })

  const updatePreset = useMutation({
    mutationFn: (data: ThemePresetFormValues) => adminApi.themePresets.update(id!, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['admin', 'theme-presets'] })
      qc.invalidateQueries({ queryKey: ['admin', 'theme-preset', id] })
      navigate('/theme-presets')
    },
  })

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <Link
          to="/theme-presets"
          className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground"
        >
          <ChevronLeft className="h-4 w-4" />
          Kembali
        </Link>
      </div>

      <div>
        <h1 className="text-2xl font-bold">Edit Tema Preset</h1>
        <p className="text-sm text-muted-foreground">
          {preset ? preset.name : 'Memuat...'}
        </p>
      </div>

      {isLoading && (
        <p className="text-sm text-muted-foreground">Memuat data tema...</p>
      )}

      {error && (
        <p className="text-sm text-destructive">
          Gagal memuat tema: {(error as Error).message}
        </p>
      )}

      {preset && (
        <ThemePresetForm
          initialValues={preset}
          onSubmit={(values) => updatePreset.mutate(values)}
          isSaving={updatePreset.isPending}
          saveError={updatePreset.error?.message ?? null}
          submitLabel="Simpan Perubahan"
        />
      )}
    </div>
  )
}
